/*=========================================================================================
  File Name: moduleSpaceGetters.js
  Description: Space Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  filteredCollege: state => state.univList.filter((item) => {
    return item.name == state.keyWord || item.name.includes(state.keyWord)
  }),
  sortedUnivName: state => JSON.parse(JSON.stringify(state.univList)).sort((a, b) => {
    return a.name.localeCompare(b.name)
  }),
  filteredUnivLocal: state => state.univList.filter((item) => {
    if(item.region == '서울특별시')
      return item.region = 1
  }),
}
